import { ArrivalGuideEditor } from '@/features/properties/arrival-guide';
import { useObjectDetail } from './ObjectDetailContext';

/**
 * Anfahrt des Objekts. Sie gehört hierher und nicht ans Apartment: der Weg zur Haustür ist für alle
 * Wohnungen im Haus derselbe — einmal pflegen statt sechsmal.
 */
export function ObjectArrivalTab() {
  const { groupId, canEdit } = useObjectDetail();
  return (
    <section aria-labelledby="object-arrival-title" className="space-y-4">
      <div>
        <h2 id="object-arrival-title" className="text-ink font-serif text-2xl">
          Anfahrt
        </h2>
        <p className="text-ink-soft mt-1 max-w-3xl text-sm">
          Schritt für Schritt bis zur Wohnungstür – so, wie der Gast es mit dem Koffer in der Hand
          liest. Gilt für alle Apartments; einzelne Schritte lassen sich im Apartment überschreiben.
        </p>
      </div>
      <ArrivalGuideEditor scope={{ kind: 'object', id: groupId }} canEdit={canEdit} />
    </section>
  );
}
